import createPersist from '~/utils/persist';

const DEFAULT_REPORT_SETTINGS = {
  showChart: true,
};

export default class ReportSettings {
  constructor() {
    this.persistService = createPersist('reportSettings');
  }

  get settings() {
    return this.persistService.get('settings') || DEFAULT_REPORT_SETTINGS;
  }

  getSetting(key) {
    return this.settings[key];
  }

  saveSettings(settingsToSet) {
    const newSettings = Object.assign({}, this.settings, settingsToSet);

    this.persistService.set('settings', newSettings);

    return newSettings;
  }

  saveSetting(key, value) {
    this.saveSettings({
      [key]: value,
    });

    return value;
  }

  get showChart() {
    return this.getSetting('showChart');
  }

  setShowChart(showChart) {
    this.saveSettings({ showChart });
  }
}
